import { Component, Input, OnInit } from '@angular/core';
import Chart from 'chart.js';
import {
  chartOptions,
  parseOptions,
  randomColor,
  chartBarStackedData,
  chartDoughnutData,
  chartPolarData,
  chartPieData,
  chartPointsData,
  chartSalesData,
  chartBarsData,
  chartHorizontalBarsData,
} from '../../variables/charts-variables';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements OnInit {
  @Input() chartTitle;
  @Input() chartData;
  @Input() chartType;
  @Input() chartDataType;

  dataTypeHelpeer = {
    chartBarStackedData,
    chartDoughnutData,
    chartPolarData,
    chartPieData,
    chartPointsData,
    chartSalesData,
    chartBarsData,
    chartHorizontalBarsData,
  };

  constructor() {}

  ngOnInit(): void {
    parseOptions(Chart, chartOptions());

    var chartBarStacked = document.getElementById('chart-bar-stacked');

    chartBarStackedData.data = this.chartData;

    let chartDataType = this.getChartDataType(this.chartDataType);

    var barStackedChart = new Chart(chartBarStacked, {
      type: this.chartType,
      data: chartDataType.data,
      options: chartDataType.options,
    });
  }

  getChartDataType(dataType) {
    return this.dataTypeHelpeer[dataType];
  }
}
